<template>
  <div>
    <div class="info-key">{{ $t("message.votesCounted") }}:</div>
    <div class="info-value">
      {{ commas(totalVotes) }}
    </div>
  </div>
</template>

<script>
import { commas } from "@/filters";

const props = {
  totalVotes: {
    type: Number,
    required: false,
  },
};

const methods = {
  commas,
};

export default {
  props,
  methods,
};
</script>
